// custom url here
// const url = "http://localhost:3000";

// const url = "https://swaraamusic.onrender.com";

// export const API = `http://localhost:5000`;
export const API = `https://swaraamusic.onrender.com`;
